import React, { useEffect } from 'react';
import { HealthcareActionContext, HealthcareContext } from '../contexts/HealthcareContext';
import { AppContext } from '../contexts/appContext';
import HealthcareLandingModal from '~/components/HealthcareLandingModal/HealthcareLandingModal';
import { isHealthcareVertical } from '@sunbit-dev/purchase-common/src/helpers/verticals';

const HealthcareModalContainer = () => {
  const { isHealthcare, shouldDisplayNotice } = React.useContext(HealthcareContext);
  const { setIsHealthcare, setShouldDisplayNotice } = React.useContext(HealthcareActionContext);
  const {
    retailer: { merchantVertical },
  } = React.useContext(AppContext);

  useEffect(() => {
    setIsHealthcare(isHealthcareVertical(merchantVertical));
  }, [merchantVertical]);

  const onSubmit = () => {
    setShouldDisplayNotice(false);
  };

  return (
    <HealthcareLandingModal
      {...{
        isOpen: isHealthcare && shouldDisplayNotice,
        blueButtonText: 'Continue',
        submit: onSubmit,
      }}
    />
  );
};

export default HealthcareModalContainer;
